import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { ref: "rootElement" }
const _hoisted_2 = {
  key: 0,
  class: "opPaginationContainer top"
}
const _hoisted_3 = { class: "opItemsPerPageContainer" }
const _hoisted_4 = { class: "me-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: 10 }, "10", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: 25 }, "25", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: 50 }, "50", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: 100 }, "100", -1)
const _hoisted_9 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  class: "mb-4",
  style: {"width":"100%","overflow-x":"auto"}
}
const _hoisted_12 = {
  class: "opTable",
  ref: "tableRoot"
}
const _hoisted_13 = {
  key: 1,
  class: "opPaginationContainer bottom"
}
const _hoisted_14 = { class: "me-2" }
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showUpperPagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            (!_ctx.hideClearFilters)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-sm btn-cyan",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClearFilters && _ctx.onClearFilters(...args)))
                }, " Clear filters "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, "Items: " + _toDisplayString(_ctx.totalItemsCount), 1),
            _withDirectives(_createElementVNode("select", {
              class: "opItemsPerPage",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemsPerPage) = $event))
            }, _hoisted_9, 512), [
              [_vModelSelect, _ctx.itemsPerPage]
            ]),
            _createElementVNode("div", {
              class: "opPaginationNumber",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.subtractPage && _ctx.subtractPage(...args)))
            }, " < "),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["opPaginationNumber", {selected: _ctx.selectedPage == i}]),
                key: i,
                onClick: ($event: any) => (_ctx.setSelectedPage(i))
              }, _toDisplayString(i), 11, _hoisted_10))
            }), 128)),
            _createElementVNode("div", {
              class: "opPaginationNumber",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addPage && _ctx.addPage(...args)))
            }, " > ")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("table", _hoisted_12, [
        _renderSlot(_ctx.$slots, "default", { data: _ctx.items })
      ], 512)
    ]),
    (_ctx.showLowerPagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, "Items: " + _toDisplayString(_ctx.totalItemsCount), 1),
          _createElementVNode("div", {
            class: "opPaginationNumber",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.subtractPage && _ctx.subtractPage(...args)))
          }, " < "),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["opPaginationNumber", {selected: _ctx.selectedPage == i}]),
              key: i,
              onClick: ($event: any) => (_ctx.setSelectedPage(i))
            }, _toDisplayString(i), 11, _hoisted_15))
          }), 128)),
          _createElementVNode("div", {
            class: "opPaginationNumber",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addPage && _ctx.addPage(...args)))
          }, " > ")
        ]))
      : _createCommentVNode("", true)
  ], 512))
}